import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  activeRequests = 0;

  /**
   * URLs for which the loading screen should not be enabled
   */
  skipUrls = [
    // '/login',
    '/assets',
    '/export',
    'tests/send/report'
  ];

  constructor(private loadingService: LoadingService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let displayLoading = true;

    for (const skipUrl of this.skipUrls) {
      if (new RegExp(skipUrl).test(request.url)) {
        displayLoading = false;
        break;
      }
    }

    const spinnerDisabled = Number(localStorage.getItem('spinnerDisabled'));
    if (spinnerDisabled > 0) {
      displayLoading = false;
      localStorage.setItem('spinnerDisabled', (spinnerDisabled - 1).toString());
    }

    if (displayLoading) {
      // if (this.activeRequests === 0) {
      this.loadingService.startLoading();
      // }
      this.activeRequests++;

      return next.handle(request).pipe(
        finalize(() => {

          this.activeRequests--;
          if (this.activeRequests === 0) {
            this.loadingService.stopLoading();
          }
        })
      );
    } else {
      return next.handle(request);
    }
  }

}
